// extracted by mini-css-extract-plugin
export default {"stepsCounter":"DRCNx","whiteCounter":"EgRPL"};